import api from "../utils/api";
import { API_CONFIG } from "../utils/apiConfig";

export const initNegotiation = async ({ company_id, product_id, user_id, original_amount, starting_price, ending_price, initial_context }) => {
    try {
        const response = await api.post(API_CONFIG.NEGOTIATIONS.INIT, {
            company_id,
            product_id,
            user_id,
            original_amount,
            starting_price,
            ending_price,
            initial_context
        });
        return response.data;
    } catch (error) {
        console.error('Init negotiation error:', error);
        return { status: "error", error: error.response?.data?.error || "Failed to initialize negotiation" };
    }
};

export const updateNegotiationContext = async (sessionId, { final_context, agreed_amount, product_id }) => {
    try {
        const response = await api.put(`${API_CONFIG.NEGOTIATIONS.UPDATE_CONTEXT}/${sessionId}/context`, {
            final_context,
            agreed_amount,
            product_id
        });
        return response.data;
    } catch (error) {
        console.error('Update negotiation context error:', error);
        return { status: "error", error: error.response?.data?.error || "Failed to update negotiation context" };
    }
};

export const acceptNegotiation = async (sessionId, { agreed_amount, actor = 'buyer' }) => {
    try {
        const response = await api.post(`${API_CONFIG.NEGOTIATIONS.ACCEPT}/${sessionId}/accept`, {
            agreed_amount,
            actor
        });
        return response.data;
    } catch (error) {
        console.error('Accept negotiation error:', error);
        return { status: "error", error: error.response?.data?.error || "Failed to accept negotiation" };
    }
};

export const cancelNegotiation = async (sessionId) => {
    try {
        const response = await api.post(`${API_CONFIG.NEGOTIATIONS.CANCEL}/${sessionId}/cancel`);
        return response.data;
    } catch (error) {
        console.error('Cancel negotiation error:', error);
        return { status: "error", error: error.response?.data?.error || "Failed to cancel negotiation" };
    }
};

export const verifyCheckout = async (items, userId = null) => {
    try {
        const response = await api.post(API_CONFIG.NEGOTIATIONS.VERIFY_CHECKOUT, { items, user_id: userId });
        return response.data;
    } catch (error) {
        console.error('Verify checkout error:', error);
        return { status: "error", error: error.response?.data?.error || "Failed to verify checkout" };
    }
};

export const getNegotiation = async (sessionId) => {
    try {
        const response = await api.get(`${API_CONFIG.NEGOTIATIONS.GET_SESSION}/${sessionId}`);
        return response.data;
    } catch (error) {
        console.error('Get negotiation error:', error);
        return { status: "error", error: error.response?.data?.error || "Failed to fetch negotiation" };
    }
};

export const logConversation = async (sessionId, { action, message, actor = 'buyer', new_amount, metadata }) => {
    try {
        const response = await api.post(`${API_CONFIG.NEGOTIATIONS.LOG}/${sessionId}/log`, {
            action,
            message,
            actor,
            new_amount,
            metadata
        });
        return response.data;
    } catch (error) {
        console.error('Log conversation error:', error);
        return { status: "error", error: error.response?.data?.error || "Failed to log conversation" };
    }
};

export const getActiveSession = async (productId, userId) => {
    try {
        const response = await api.get(`${API_CONFIG.NEGOTIATIONS.ACTIVE_PRODUCT}/${productId}/active/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Get active session error:', error);
        return { status: "error", error: error.response?.data?.error || "Failed to fetch active session" };
    }
};
